import { shallowRef } from "vue";

export const externalRedirect = shallowRef(null);

export const redirectExternally = (url) => {
  externalRedirect.value = { url };
  window.location.replace(url);
};
